import notify from "devextreme/ui/notify";
import { sleep } from "effection";
import produce from "immer";
import { omit, pick } from "lodash";
import {
  compose,
  filter,
  keyBy,
  keys,
  map,
  max,
  parseInt as loParseInt,
} from "lodash/fp";
import { createAction, createAssign, createTable, MapEntity } from "robodux";
import {
  all,
  ApiCtx,
  call,
  delay,
  put,
  select,
  spawn,
  takeLatest,
  UndoCtx,
} from "saga-query";
import { updateStore } from "starfx";

import { listParams } from "@app/components/lists/lxr_common_definitions";
import { ensureArray, noCase } from "@app/service/helpers";
import { inApi, inThunks, ThunkCtx } from "@app/state/apis/api";
/* 
THE SHORT VERSION:
uilist registerss a requets to pollMappMiddleware 
to call the preFetchController 
to check if is necessary to run selectApi
=== over engineering ===
*/
import {
  CONST_LIST_OF_MYWORK,
  CONST_LIST_SS_OF_INVOICE,
  CONST_LISTORIGIN_AVOCATI,
  CONST_LISTORIGIN_CTRDOSARE,
  CONST_LISTORIGIN_INVOICE,
  CONST_LISTORIGIN_PROFORMA,
  CONST_LISTORIGIN_WORK,
  CONST_listUiState,
  CONST_LSTGRP_IMPLICIT,
  CONST_LSTGRP_USER,
  CONST_LSTORIGIN_CONTACTE,
  CONST_LSTORIGIN_CONTPERS_MD,
  CONST_LSTORIGIN_PERSOANE,
  CONST_PREFIX_FROM_JS,
} from "@app/state/insider/constants";
import {
  pSubscribeListOfAvocati,
  pSubscribeListOfContacts,
  pSubscribeListOfCtrDosare,
  pSubscribeListOfInvoices,
  pSubscribeListOfMywork,
  pSubscribeListOfPersons,
  pSubscribeListOfProforme,
  pUnsubscribeListOfAvocati,
  pUnsubscribeListOfContacts,
  pUnsubscribeListOfCtrDosare,
  pUnsubscribeListOfInvoices,
  pUnsubscribeListOfMywork,
  pUnsubscribeListOfPersons,
  pUnsubscribeListOfProforme,
} from "@app/state/insider/lists";
import { select_api_login_amaid } from "@app/state/insider/login";
import { select_apiProf_usersRaw } from "@app/state/insider/profilesApi";
import {
  getInvoiceOnSelectApi,
  getProformeOnSelectApi,
} from "@app/state/insider/selectApi";
import { RootState } from "@app/state/rootState";
import {
  IDBLxReportOption,
  ILxReportBase,
  ILxReportOption,
  TDBMyworkCriteria,
  TSyncObjectMenuOpened,
  TUndoableOparationPayload,
  TUndoableOperation,
} from "@app/types/insider";
import { createSelector } from "@reduxjs/toolkit";

import type { Next } from "saga-query";
/* -------------------------------------------------------------------------- */
const listUiState = CONST_listUiState;
const listModelState = "listModels";
const ENDPOINT_LIST_OF_MYWORK = CONST_LIST_OF_MYWORK;
const ENDPOINT_LIST_OF_INVOICES = CONST_LIST_SS_OF_INVOICE;
/* -------------------------------------------------------------------------- */

//TODO #11 Auto-UNSUBSCRIBE polling when needed
/* -------------------------------------------------------------------------- */
export const LISTREPORT_MAP = new Map([
  [
    CONST_LSTORIGIN_CONTACTE,
    {
      fn: run_list_contacte_origin,
      // grid: 'contactsGrid',
    },
  ],
  [
    CONST_LSTORIGIN_PERSOANE,
    {
      fn: run_list_personane_origin,
      // grid: 'personsGrid',
    },
  ],
  [
    CONST_LSTORIGIN_CONTPERS_MD,
    {
      fn: run_list_contpers_md_origin,
      // grid: 'contactsPersonsMdGrid',
    },
  ],
  [
    CONST_LISTORIGIN_WORK,
    {
      fn: run_list_work_origin,
      // grid: 'odGrid',
      // grid: 'directGridModel', // example //
    },
  ],
  [
    CONST_LISTORIGIN_AVOCATI,
    {
      fn: run_list_avocati_origin,
      // grid: 'avocatiGrid',
    },
  ],
  [
    CONST_LISTORIGIN_CTRDOSARE,
    {
      fn: run_list_ctrdosare_origin,
      // grid: 'ctrdosareGrid'
    },
  ],
  [
    CONST_LISTORIGIN_PROFORMA,
    {
      fn: run_list_proforma_origin,
    },
  ],
  [CONST_LISTORIGIN_INVOICE, { fn: run_list_invoice_origin }],
]);
/* -------------------------------------------------------------------------- */
let namei = 0;
// todo - move this to database:
const liGroups: ILxReportBase[] = [
  {
    id: 1,
    name: "Contacte",
    text: "principalele campuri de la companii si persoane de contact",
  },
  {
    id: 2,
    name: "Contracte/Dosare",
    text: "date generale despre starea contractelor",
  },
  { id: 3, name: "Activitati", text: "timesheet" },
  {
    id: 4,
    name: "Facturi emise",
    text: "date generale despre devize, estimari sau facturi emise",
  },
  {
    id: 5,
    name: "Facturi fiscale emise",
    text: "date generale despre facturile emise cu regim fiscal",
    visible: false,
  },
  {
    id: 6,
    name: "Alte liste",
    text: "liste diverse cu informatii generale",
    visible: false,
  },
];

type TListReportSelectionUi = {
  lxGroupId: number | null;
  lxReportId: number | null;
  lxReportName: string | null;
  status: string | null;
  // grid: object;
};
type TListReportGridUi = {
  access: "PUBLIC" | "PRIVATE";
};
type TListReportTempUi = TListReportSelectionUi & TSyncObjectMenuOpened;
type TListReportUi = TListReportSelectionUi & TListReportGridUi;

interface PatchEntity<T> {
  [key: string]: Partial<T[keyof T]>;
}

const applyReadonly = (x: IDBLxReportOption, meAmaId: number) => {
  if (x.READONLY || x.GROUP_DISPLAY_NAME === CONST_LSTGRP_IMPLICIT) {
    return true;
  }
  if (x.OWNER_AMA === meAmaId) {
    return false;
  }
  return Boolean(+x.READONLY);
};

const blobState = (blob: string) => {
  try {
    return JSON.parse(blob);
  } catch (e) {
    return {};
  }
};

const processLoadLists = (
  data: IDBLxReportOption[],
  meAmaId: number
): MapEntity<ILxReportOption> => {
  return compose(
    keyBy((x: ILxReportOption) => x.id),
    map((item: IDBLxReportOption) => {
      const blob = blobState(item.B_GRIDSTATE);
      return {
        id: item.KLR_ID,
        group: item.KLR_GROUP,
        name: item.LIST_NAME,
        displayName: item.LIST_DISPLAY_NAME,
        displayGroup: item.GROUP_DISPLAY_NAME,
        // liGroups.find((x) => x.id === item.KLR_GROUP)
        //   ?.name as TLxReportDisplayGroup,
        text: item.TEXT,
        access: item.ACCESS,
        readonly: applyReadonly(item, meAmaId),
        ownerAma: item.OWNER_AMA,
        selectionOptions: blob?.selectionOptions || {},
        state: blob,
        params_default: {},
        params_mandatory: [],
        params_optional: [],
      };
    })
  )(data);
};
const initialUi: TListReportSelectionUi = {
  lxGroupId: null,
  lxReportId: null,
  lxReportName: null,
  status: null,
  // grid: null, //TODO :remove this
};
const initialTempUi: TListReportTempUi = {
  ...initialUi,
  MenuOpened: false,
};
const initialLoadedUi: TListReportUi = {
  ...initialUi,
  access: "PUBLIC",
};
const initialState = {
  tempUi: initialTempUi,
  loadedUi: initialLoadedUi,
  listGroups: liGroups, // list on left
  lxrMapOptions: Object.fromEntries(
    Array.from(LISTREPORT_MAP.keys()).map((x) => [x, {}])
  ), // list on right
};
export const repoUi = createAssign<any>({
  name: listUiState,
  initialState,
  extraReducers: {
    LISTREP_RESET_TEMPUI: (state: any, payload: any) =>
      produce(state, (draft: { tempUi: TListReportTempUi }) => {
        draft.tempUi = initialState.tempUi;
      }),
    LISTREP_PUT_TEMPUI: (
      state: any,
      payload:
        | ArrayLike<unknown>
        | {
            [s: string]: unknown; //
          }
    ) =>
      produce(state, (draft: { tempUi: { [x: string]: unknown } }) => {
        if (typeof payload === "object") {
          Object.entries(payload).forEach(([key, value]) => {
            draft.tempUi[key] = value;
          });
        } else {
          if (process.env.NODE_ENV === "development") {
            alert("object expected #432");
          }
        }
      }),
    LISTREP_SET_TEMPUI: (
      state: any,
      payload: ArrayLike<unknown> | { [s: string]: unknown }
    ) =>
      produce(state, (draft: { tempUi: { [x: string]: unknown } }) => {
        if (typeof payload === "object") {
          Object.entries(payload).forEach(([key, value]) => {
            if (!key.startsWith("::")) {
              draft.tempUi[key] = value;
            }
          });
        } else {
          if (process.env.NODE_ENV === "development") {
            alert("object expected #433");
          }
        }
      }),
    LISTREP_RELOAD_TEMPUI: (state: any, payload: any) =>
      produce(
        state,
        (draft: {
          tempUi: any;
          loadedUi: {
            lxGroupId: any;
            lxReportId: any;
            lxReportName: any;
            status: any;
          };
        }) => {
          Object.assign(draft.tempUi, {
            lxGroupId: draft.loadedUi.lxGroupId,
            lxReportId: draft.loadedUi.lxReportId,
            lxReportName: draft.loadedUi.lxReportName,
            status: draft.loadedUi.status,
            // grid: draft.loadedUi.grid,
            MenuOpened: true,
          });
        }
      ),
    LISTREP_FINALIZE_TEMPUI: (state: any) =>
      produce(state, (draft: { loadedUi: any; tempUi: any }) => {
        Object.assign(draft.loadedUi, omit(draft.tempUi, ["MenuOpened"]));
      }),
    LISTREP_RESET_LOADEDUI: (state: any, payload: any) =>
      produce(state, (draft: { loadedUi: TListReportUi }) => {
        draft.loadedUi = initialState.loadedUi;
      }),
    [`criteria/${ENDPOINT_LIST_OF_MYWORK}`]: (
      state: any,
      payload: TDBMyworkCriteria[]
    ) =>
      produce(
        state,
        (draft: {
          lxrMapOptions: {
            [x: string]: {
              criteria: {
                USER:
                  | { startsfrom: string; maxInterval: number | null }
                  | undefined;
                GROUP:
                  | { startsfrom: string; maxInterval: number | null }
                  | undefined;
              };
            };
          };
        }) => {
          const userData = payload.find((x) => x.USER_GROUP === "USER");
          const groupData = payload.find((x) => x.USER_GROUP === "GROUP");
          // just create the object if it doesn't exist
          if (userData || groupData) {
            if (!draft.lxrMapOptions[CONST_LISTORIGIN_WORK]?.criteria) {
              draft.lxrMapOptions[CONST_LISTORIGIN_WORK] = {
                criteria: {
                  USER: userData
                    ? {
                        startsfrom: userData.START_DATE,
                        maxInterval: userData.YEAR_INTERVALS,
                      }
                    : undefined,
                  GROUP: groupData
                    ? {
                        startsfrom: groupData.START_DATE,
                        maxInterval: groupData.YEAR_INTERVALS,
                      }
                    : undefined,
                },
              };
            }
          }
        }
      ),
    [`criteria/${ENDPOINT_LIST_OF_INVOICES}`]: (state: any, payload: any) =>
      produce(
        state,
        (draft: { lxrMapOptions: { [x: string]: { criteria: any } } }) => {
          draft.lxrMapOptions[CONST_LISTORIGIN_INVOICE] = {
            criteria: payload,
          };
        }
      ),
  },
});
//
export const repoListModels = createTable<ILxReportOption>({
  name: listModelState,
});

// actions:
export const listrReporstResetTempUi = createAction("LISTREP_RESET_TEMPUI");
export const listReportsSetTempUiKV =
  createAction<object>("LISTREP_SET_TEMPUI");

export const listReportsPutTempUiKV =
  createAction<object>("LISTREP_PUT_TEMPUI");
export const uiListTempUiSetMenuOpened_withSyncOption =
  createAction<TSyncObjectMenuOpened>(
    `${CONST_PREFIX_FROM_JS}uiList/tempUi/setMenuOpened`
  );
//avoid to export this, preventing skip of delphi sync//
export const uiListTempUiSetMenuOpened_afterSync = createAction<{
  MenuOpened: any;
}>("uiList/tempUi/setMenuOpened");
const uliListTempUiFinalize = createAction("LISTREP_FINALIZE_TEMPUI");
const uiListReloadTempUi = createAction("LISTREP_RELOAD_TEMPUI");
const uiSelectionSetDetail =
  createAction<ILxReportOption>("LISTREP_SET_DETAIL");

// export const listExecuteSetModel = createAction<ILxReportOption>(
//   'POST_LXREP_UNDOABLE',
// );
// export const listExecuteCancelSetModel = createAction<ILxReportOption>(
//   'UNDO_LXREP_UNDOABLE',
// );
export const listPrepareSetModel =
  createAction<TUndoableOparationPayload>("SET_LXREP_UNDOABLE");
/* -------------------------------------------------------------------------- */
//selectors:
const selectListReportUis = (state: { [x: string]: any }) => state[repoUi.name];
//
const { selectTableAsList: selectModelsAsList, selectById } =
  repoListModels.getSelectors((s: RootState) => s[repoListModels.name]);

const selectModelById = createSelector(
  selectById,
  (s): ILxReportOption => s as ILxReportOption
);

const selectModelByName = createSelector(
  selectModelsAsList,
  (models: ILxReportOption[]) => {
    return keyBy((x: ILxReportOption) => x.name, models);
  }
);
const selectModelNameById = createSelector(
  selectModelById,
  (model: ILxReportOption | undefined) => {
    return model?.name;
  }
);
export const selectListReportUi_tempUi = createSelector(
  selectListReportUis,
  (state) => state.tempUi
);

export const selectListReportUi_loadedUi = createSelector(
  selectListReportUis,
  (state) => state.loadedUi
);

export const selectListReportUi_groups = createSelector(
  selectListReportUis,
  (ui) => {
    return ui.listGroups;
  }
);

// export const selectListReportModels_all = modelSelectors.tableAsList;
export const selectListReportUi_iems_all = createSelector(
  selectModelsAsList,
  (state) => state
);
const selectedGroup = createSelector(
  selectListReportUi_tempUi,
  (state) => state.lxGroupId
);
export const selectListReportUi_iems = createSelector(
  selectModelsAsList,
  selectedGroup,
  (state, group) => {
    return state.filter((x) => x.group === group);
  }
);
export const slectListReportLoadedID = createSelector(
  selectListReportUi_loadedUi,
  (state) => state.lxReportId
);
export const selectListReportCurrentState = createSelector(
  selectListReportUi_loadedUi,
  selectModelsAsList,
  (loadedUi, listDetails) => {
    const { lxReportName } = loadedUi;
    const item = listDetails.find((x) => x?.["name"] === lxReportName);
    return item?.state;
  }
);

export const selectOriginalModelOfCurrentReport = createSelector(
  selectListReportUi_loadedUi,
  selectModelsAsList,
  (loadedUi, listDetails): ILxReportOption => {
    const { lxReportName } = loadedUi;
    const item = listDetails.find((x) => x?.["name"] === lxReportName);
    return item as ILxReportOption;
  }
);
export const selectListReportUi_currentListOpsData = createSelector(
  selectListReportUis,
  selectModelsAsList,
  select_apiProf_usersRaw,
  (state, models, users) => {
    const { lxReportName } = state.tempUi;
    const item = models.find((x) => x?.["name"] === lxReportName);
    if (!item) {
      return {};
    }
    const formData = pick(item, [
      "id",
      "group",
      "name",
      "displayName",
      "displayGroup",
      "text",
      "access",
      "readonly",
      "ownerAma",
      "selectionOptions",
    ]);
    formData["ownerAma"] =
      users[`${formData["ownerAma"]}`]?.PRENUME_NUME || "Jurnal Gold";
    return formData;
  }
);

export const select_titlesIgnoreCase = createSelector(
  selectModelsAsList,
  (models) => {
    return models.map((x) => noCase(x.displayName));
  }
);

export const selectListReportLoadedUiParentName = createSelector(
  selectListReportUi_loadedUi,
  (state) => {
    if (!state.lxReportName) {
      return null;
    }
    const parentName = state.lxReportName.split("_@_AMA")[0];
    return parentName;
  }
);
/* -------------------------------------------------------------------------- */
// DEV-ONLY MOCKS:
// the most common scenario at big regular companies:
export const mock1 = {
  USER: {
    startsfrom: "2001-01-01",
    maxInterval: null,
  },
  GROUP: {
    startsfrom: "2001-01-01",
    maxInterval: 5,
  },
};
// the most common scenario at big companies:
export const mock2 = {
  USER: {
    startsfrom: "2001-01-01",
    maxInterval: null,
  },
  GROUP: {
    startsfrom: "2001-01-01",
    maxInterval: 1,
  },
};
// impossible
export const mock3 = {
  USER: {
    startsfrom: "2001-01-01",
    maxInterval: 4,
  },
};
export const mock4 = {
  USER: {
    startsfrom: "2001-01-01",
    maxInterval: null,
  },
};
const theMock = null; //mock2;
/* -------------------------------------------------------------------------- */
export const listQueryStateShowConditionForListByName = (
  state: { [x: string]: { lxrMapOptions: { [x: string]: { criteria: any } } } },
  name: string
) => {
  if (!name) {
    return false;
  }
  if (typeof name !== "string") {
    return false;
  }
  const parentName = name.split("_@_AMA")[0];
  if (!parentName) {
    return false;
  }
  // #47 [fixed aprox.] important there is no defined relation between the parent origin of the list and the endpoint of it.
  const listCrit =
    theMock || state[repoUi.name].lxrMapOptions[parentName]?.criteria;
  if (!listCrit) {
    return false;
  }
  //we will treat each case separately. if we can generalize it, we will do it later
  // parentName = LIST_WORK_ORIGIN
  if (parentName === CONST_LISTORIGIN_WORK) {
    // we will return true only if USER.maxInterval OR GROUP.maxInterval is defined
    // otherwise there is no need to show the condition
    if (listCrit?.USER?.maxInterval || listCrit?.["GROUP"]?.maxInterval) {
      return true;
    }
  }
  if (parentName === CONST_LISTORIGIN_PROFORMA) {
    return true;
  }
  if (parentName === CONST_LISTORIGIN_INVOICE) {
    // if issuers available  > 1 then show condition else not
    // [emitenti] //
    const issuers = state[repoUi.name].lxrMapOptions[parentName]?.criteria;
    return issuers?.length > 1;
  }
  return false;
};
export const listQueryStateCondOptionsForListByName = (
  state: { [x: string]: { lxrMapOptions: { [x: string]: { criteria: any } } } },
  name: string
) => {
  if (!name) {
    return null;
  }
  if (typeof name !== "string") {
    return null;
  }
  const parentName = name.split("_@_AMA")[0];
  if (!parentName) {
    return null;
  }
  // #47 [fixed aprox.] important there is no defined relation between the parent origin of the list and the endpoint of it.
  const listCrit =
    theMock || state[repoUi.name].lxrMapOptions[parentName]?.criteria;

  return listCrit || null;
};
// min date for the datepicker ...
export const selectListMyworkCriteria = createSelector(
  selectListReportUis,
  (state): any => {
    return state.lxrMapOptions[CONST_LISTORIGIN_WORK]?.criteria;
  }
);
//emitent//
export const selectListInvoiceCriteria = createSelector(
  selectListReportUis,
  (state): any => {
    return state.lxrMapOptions[CONST_LISTORIGIN_INVOICE]?.criteria;
  }
);
/* -------------------------------------------------------------------------- */
// simple apis //
// export const lxRep = createApi();
// lxRep.use(requestMonitor());
// lxRep.use(lxRep.routes());
// lxRep.use(errorHandler);
// lxRep.use(fetcher({ baseUrl: service }));

export const getListDefinition = inApi.get(
  "/reports/listrepordef",
  function* (ctx: UndoCtx<any, any>, next) {
    ctx.undoable = false;
    ctx.request = ctx.req({
      url: "/reports/listreportdetails",
      method: "get",
    });
    yield* next();
    if (!ctx.json.ok) {
      return;
    }
    const { data, ok } = yield ctx.json;
    if (!ok) {
      return;
    }
    const meAma = yield* select(select_api_login_amaid);
    yield* put(repoListModels.actions.set(processLoadLists(data, meAma)));
  }
);
type TPrevAndSet = {
  prevS: ILxReportOption;
  setS: ILxReportOption;
};
export const postListDefinition = inApi.post<TPrevAndSet>(
  "/reports/listrepordef",
  function* (ctx: ApiCtx<any, any, any>, next) {
    // ctx.undoable = false;
    const weSendModel = yield* ctx.payload.setS;
    const mainfield = omit(weSendModel, ["state"]);
    // on savaacopy is string, on saveas is object//
    const stateFieldAsString =
      typeof weSendModel.state === "object"
        ? JSON.stringify(weSendModel.state)
        : weSendModel.state;
    const stateObj = {
      ...mainfield,
      state: stateFieldAsString,
    };
    ctx.request = ctx.req({
      url: "/reports/listrepordef",
      method: "POST",
      body: JSON.stringify(stateObj),
    });
    yield* next();
    if (!ctx.json.ok) {
      yield showNotification(
        "A survenit o eroare la conexiune [#439]. Nu se poate opera modificarea",
        "error"
      );
      return;
    }
    const result = yield* call(
      applyUpsertLogic,
      ctx.payload.prevS,
      ctx.payload.setS,
      ctx.json
    );
    if (result) {
      yield* put(repoListModels.actions.add({ [result.id]: result }));
    } else {
      yield showNotification(
        "A survenit o eroare la conexiune [#439]. Nu se poate opera modificarea",
        "error"
      );
    }

    // yield* put(repoListModels.actions.add({ [result.id]: result }));
  }
);

export const deleteListDefinition = inApi.delete<TPrevAndSet>(
  "/reports/listrepordef",
  function* (ctx: ApiCtx<any, any>, next) {
    // ctx.undoable = false; //
    const { id } = yield ctx.payload.prevS;
    if (!id) {
      alert("Nu se poate sterge un model care nu are id");
      return;
    }
    //being lazy in DELPHI the params are query string
    // and in nodejs they are in the body (fixme)
    ctx.request = ctx.req({
      url: `/reports/listrepordef/?id=${id}`, //fixme in delphi
      method: "DELETE",
      body: JSON.stringify({ id }), //ok for nodejs
    });
    yield* next();
    if (!ctx.json.ok) {
      yield showNotification(
        "A survenit o eroare la conexiune [#1008]. Nu se poate opera modificarea",
        "error"
      );
      return;
    }
    const result = yield* call(applyDeleteLogic, ctx.payload.prevS, ctx.json);
    if (result) {
      yield* put(repoListModels.actions.remove([`${result}`]));
    }
  }
);

// some list selection criteria for this user
export const lxMyWorkCriteria = inApi.get(
  "/select/ss_mywork_criteria",
  function* (ctx: ApiCtx<any, any>, next) {
    yield* delay(1000);
    yield* next();
    if (!ctx.json.ok) {
      return;
    }
    const { ok, data } = yield ctx.json;
    if (!ok) {
      return;
    }
    if (data["error"]) {
      yield notify(data["error"], "error", 2000);
      return;
    }
    yield* put({ type: `criteria/${ENDPOINT_LIST_OF_MYWORK}`, payload: data });
    const group = ensureArray([...data]).find((x) => x.USER_GROUP === "GROUP");
    if (group) {
      const startdate = group.START_DATE;
      if (startdate) {
        // yield* put(getExchangeRates({ startdate }));
        // inject starfx date//
        yield* window.fx.run(
          updateStore((s) => {
            s.app.absolutestart = startdate;
          })
        );
      }
    }
  }
);
export const lxInvoiceCriteria = inApi.get(
  "/select/ss_invoice_criteria",
  function* (ctx: ApiCtx<any, any>, next) {
    yield* delay(800);
    yield* next();
    if (!ctx.json.ok) {
      return;
    }
    const { ok, data } = yield ctx.json;
    if (!ok) {
      return;
    }
    if (data["error"]) {
      yield notify(data["error"], "error", 2000);
      return;
    }
    yield* put({
      type: `criteria/${ENDPOINT_LIST_OF_INVOICES}`,
      payload: data,
    });
  }
);

export const cleanupListUi = inThunks.create(
  "inThunks/cleanupListUi",
  function* (ctx: ThunkCtx, next: Next) {
    yield* put(repoUi.actions.reset());
    yield* next();
  }
);
/* -------------------------------------------------------------------------- */
// sagas:
function* showNotification(message: string, type = "warning") {
  yield notify(
    {
      message: message,
      width: 360,
      position: {
        at: "top",
        my: "top",
        of: "#main",
        offset: "0 22",
      },
    },
    type,
    4500
  );
}
function* areParamsHappy(
  pRunning: any,
  pDefault: any,
  pMandatory: any,
  pOptional: any
): Generator<any, any, boolean> {
  if (!pMandatory) {
    return true;
  }
  const mandatoryParams = ensureArray(pMandatory);
  const paramsSet = { ...pDefault, ...pRunning };
  yield;
  return Object.keys(paramsSet).every((key) => mandatoryParams.includes(key));
}
function* doListReportSelectionChanged(action: { payload: any }) {
  const { payload } = action;
  const { lxReportName, lxReportId } = payload;
  if (lxReportName) {
    const theReport = yield* select(selectModelById, {
      id: lxReportId,
    });
    if (payload["::sender"] === "handleListDetailsSelectionChange") {
      // just show the report options
      return;
    }
    // yield; // why was this here?
    //if nothing to do next then launch the report
    if (theReport) {
      const { params, params_default, params_mandatory, params_optional } =
        theReport;
      const areParamsSet = yield* call(
        areParamsHappy,
        params,
        params_default,
        params_mandatory,
        params_optional
      );
      //
      if (areParamsSet) {
        const parentName = lxReportName.split("_@_AMA")[0];
        const cmdChain = LISTREPORT_MAP.get(parentName) as any;
        if (cmdChain) {
          // yield* put(listReportsPutTempUiKV({ grid: cmdChain.grid })); // TODO: remove this
          yield* all([
            put(
              uiListTempUiSetMenuOpened_withSyncOption({
                MenuOpened: false,
                ButtonState: "enabled",
              })
            ),
            put(uliListTempUiFinalize()),
            put(listrReporstResetTempUi()), // or just freeze the state the wait for  proper actions //
          ]);
          const thisAmaId = yield* select(select_api_login_amaid);
          const { watch, apiName, cancel, ...rest } = payload?.args || {};
          yield* call(cmdChain.fn, [
            "OPEN",
            { watch, apiName, cancel, thisAmaId, ...rest },
          ]);
        }
      }
    }
  }
}
function* doSyncedMenuOpen(action: { payload: { MenuOpened: string } }) {
  const { MenuOpened: prevState } = yield* select(selectListReportUi_tempUi);
  let newState;
  if (action.payload?.MenuOpened === "TOGGLE") {
    newState = !prevState;
  } else {
    newState = action.payload?.MenuOpened;
  }
  // on opening load the seleted report's details
  if (newState === true) {
    const theLoadedReport = yield* select(selectListReportUi_loadedUi);
    if (theLoadedReport.lxReportId) {
      yield* put(uiListReloadTempUi());
      //cancel the pending modifications if not posted
      // yield* put(listExecuteCancelSetModel());
      return; // important to avoid the sync
    }
  }
  yield* put(listReportsSetTempUiKV({ MenuOpened: newState }));
}
function* applyUpsertLogic(
  prevS: ILxReportOption | undefined,
  setS: ILxReportOption,
  opResult: any
): Generator<any, ILxReportOption | undefined, any> {
  //data signature from db: [{NEWKRKLID: number}];
  const { ok, data } = yield* opResult;
  if (!ok) {
    return prevS;
  }
  let myID: number;

  try {
    myID = yield;
    yield;
  } catch (e) {
    console.log(e);
    yield showNotification(
      "Posibila eroare la salvarea modelului. O lamurim la refresh. [#419]",
      "error"
    );
    return prevS;
  }
  //we have an update operation
  const theSentID = yield +setS.id || -1;
  yield;
  if (theSentID > 0) {
    // if result is positive then we have success
    if (myID > 0) {
      return setS;
    } else {
      //database error
      yield showNotification(
        "A survenit o eroare la salvarea modelului in baza de date [#427]. Nu se poate opera modificarea",
        "error"
      );
      return prevS;
    }
  }
  //we have an insert operation
  if (theSentID < 0) {
    if (myID > 0) {
      yield showNotification("Salvare efectuata.", "success");
      return { ...setS, id: myID };
    } else {
      //database error
      yield showNotification(
        "A survenit o eroare la salvarea modelului in baza de date [#437]. Nu se poate opera modificarea",
        "error"
      );
      return prevS;
    }
  }
}
function* applyDeleteLogic(prevS: ILxReportOption, opResult: any) {
  const { ok, data } = yield opResult;
  if (!ok) {
    yield showNotification(
      "Stergere esuata in baza de date. Contactati IT-ul [#1009]",
      "error"
    );
    return undefined;
  }

  if (ok) {
    const myID = Object.values(data[0])[0] as any;
    if (+myID > 0) {
      yield showNotification("Stergere efectuata.", "success");
      return +myID;
    } else {
      yield showNotification(
        "Stergere esuata in baza de date. Contactati IT-ul [#1009]",
        "error"
      );
      return undefined;
    }
  }
}
function* genNewName(theName: string) {
  const parent = theName.split("_@_AMA")[0];
  const theAmaId_ = yield* select(select_api_login_amaid);
  const theAmaId = theAmaId_ ? theAmaId_ : 0;
  const theReports = yield* select(selectModelByName);
  const newx = compose(
    (x: number) => x + 1,
    max,
    map(loParseInt(10)),
    map((x: string) => x.split(`_@_AMA${theAmaId}_`)?.[1] || 0),
    filter((x: string) => x.startsWith(parent)),
    keys
  )(theReports);
  return `${parent}_@_AMA${theAmaId}_${newx}`;
}

function* doListReportOperation(action: { payload: any }) {
  const { payload } = action;
  switch (Object.keys(payload)[0] as TUndoableOperation) {
    //TODO: #29  create RENAME operation
    case "SAVE": {
      const prepPayload = yield* payload.SAVE;
      //we need all the params to be set
      const originalPayload: ILxReportOption = yield* select(
        selectOriginalModelOfCurrentReport
      );
      const newParams = {
        ...originalPayload,
        ...prepPayload,
        readonly: false,
        access: [false, "false", 0].includes(prepPayload.access)
          ? "PRIVATE"
          : "PUBLIC",
      };
      yield* put(
        postListDefinition({ prevS: originalPayload, setS: newParams })
      );
      break;
    }
    case "DELETE": {
      //TODO #2 position the current selection on an existing report (fallback to root)
      const originalPayload: ILxReportOption = yield* select(selectModelById, {
        id: payload.DELETE,
      });
      yield* put(
        deleteListDefinition({ prevS: originalPayload, setS: {} as any })
      );
      break;
    }
    case "SAVEAS": {
      const prepPayload = payload.SAVEAS;
      console.log("prepPayload", prepPayload);
      //we need all the params to be set
      const originalPayload: ILxReportOption = yield* select(
        selectOriginalModelOfCurrentReport
      );
      namei = 0;
      yield;
      const newName = yield* call(genNewName, originalPayload.name);
      yield;
      const newParams = {
        ...originalPayload,
        ...prepPayload,
        id: -1,
        name: newName,
        displayGroup: CONST_LSTGRP_USER, // todo or "Favorite"
        access: [false, "false", 0].includes(prepPayload.access)
          ? "PRIVATE"
          : "PUBLIC",
        readonly: false,
      };
      yield* put(
        postListDefinition({ prevS: originalPayload, setS: newParams })
      );
      break;
    }
    case "SAVEACOPY": {
      const prepPayload = payload.SAVEACOPY;
      console.log("prepPayload", prepPayload);
      //we need all the params to be set
      const originalPayload: ILxReportOption = yield* select(selectModelById, {
        id: payload.SAVEACOPY.id,
      });
      namei = 0;
      yield;
      const newName = yield* call(genNewName, originalPayload.name);
      yield;
      const newParams = {
        ...originalPayload,
        ...prepPayload,
        id: -1,
        name: newName,
        access: ["false", false, 0].includes(prepPayload.access)
          ? "PRIVATE"
          : "PUBLIC",
        displayGroup: CONST_LSTGRP_USER, // todo or "Favorite"
        state: originalPayload.state,
      };
      yield* put(
        postListDefinition({ prevS: originalPayload, setS: newParams })
      );
      break;
    }
    case "RENAME": {
      const prepPayload = payload.RENAME;
      //we need all the params to be set
      const oriState: ILxReportOption = yield* select(selectModelById, {
        id: payload.RENAME.id,
      });
      const newParams = {
        ...oriState,
        ...prepPayload,
        access: [false, "false"].includes(prepPayload.access)
          ? "PRIVATE"
          : "PUBLIC",
        state: oriState.state,
      };
      yield* put(postListDefinition({ prevS: oriState, setS: newParams }));
      break;
    }
    case "CLOSE": {
      //disable the delphi button
      yield* put(
        uiListTempUiSetMenuOpened_withSyncOption({
          MenuOpened: true,
          ButtonState: "disabled",
        })
      );
      //[##findme1348##]
      const reporName = yield* select(selectModelNameById, {
        id: payload.CLOSE,
      }) as any;
      const parentName = reporName.split("_@_AMA")[0];
      const cmdChain = LISTREPORT_MAP.get(parentName) as any;
      //UNSUBSCRIBE//
      yield* call(cmdChain.fn, ["CLOSE"]);
      //CLEANUP//
      yield* put({ type: "LISTREP_RESET_LOADEDUI" });
      break;
    }
    default:
      break;
  }
  yield;
}
export function* watchModelOperations() {
  yield* takeLatest<any>("SET_LXREP_UNDOABLE", doListReportOperation);
}
export function* watchLxReportCalls() {
  yield* takeLatest<any>("LISTREP_SET_TEMPUI", doListReportSelectionChanged);
}
export function* watchMenuOpenLocally() {
  yield* takeLatest<any>(uiListTempUiSetMenuOpened_afterSync, doSyncedMenuOpen);
}

/* -------------------------------------------------------------------------- */

function* run_list_contacte_origin(args: any) {
  // yield* put(listExecuteCancelSetModel());
  yield;
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
      };
      // yield* put(pSubscribeListOfContacts(p));
      break;
    }
    case "CLOSE": {
      // yield* put(pUnsubscribeListOfContacts());
      break;
    }
    default:
      break;
  }
}

function* run_list_personane_origin(args: any) {
  yield* sleep(0);
  // close and stop whatever is running
  // yield* put(listExecuteCancelSetModel());
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
      };
      // yield* put(pSubscribeListOfPersons(p));
      break;
    }
    case "CLOSE": {
      // yield* put(pUnsubscribeListOfPersons());
      break;
    }
    default: {
      break;
    }
  }
}

function* run_list_contpers_md_origin(args: any) {
  yield* sleep(0);
  // close and stop whatever is running
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
      };
      // yield* put(pSubscribeListOfContacts(p));
      // yield* put(pSubscribeListOfPersons(p));
      break;
    }
    case "CLOSE": {
      // yield* put(pUnsubscribeListOfContacts());
      // yield* put(pUnsubscribeListOfPersons());
      break;
    }
    default: {
      break;
    }
  }
}

function* run_list_work_origin(args: TUndoableOparationPayload) {
  yield* sleep(0);
  // close and stop whatever is running
  // yield* put(listExecuteCancelSetModel());
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      // minimal validation //
      if (!params) {
        yield* call(
          showNotification,
          "Lipsesc parametrii de selectie",
          "error"
        );
        return;
      }
      //accept if start end and ama are present. ama can be 0 (for group) and is truthy
      if (!(params.start && params.end && (params.ama || params.ama === 0))) {
        yield* call(
          showNotification,
          "Parametrii de selectie incompleti",
          "error"
        );
        return;
      }
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
        apiName: params?.apiName ? params.apiName : "select",
      };
      /*  
      select | transfer | direct
      this will trigger different api calls
      providing the same data by different means
      (view readme.md for more info)
      */
      if (["select", "transfer"].includes(p.apiName)) {
        // THIS IS THE CALL FOR MYWORK LIST: //
        // yield* put(pSubscribeListOfMywork(p));
        return;
      }

      // EXAMPLE OF DIRECT CALL: //
      if (p.apiName === "direct") {
        listParams.setWork(p.start, p.end);
      }
      break;
    }
    case "CLOSE": {
      listParams.setWork(null, null);
      break;
    }
    default: {
      break;
    }
  }
}

function* run_list_avocati_origin(args: any) {
  yield* sleep(0);
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
      };
      // yield* put(pSubscribeListOfAvocati(p));
      break;
    }
    case "CLOSE": {
      // yield* put(pUnsubscribeListOfAvocati());
      break;
    }
    default: {
      break;
    }
  }
}

function* run_list_ctrdosare_origin(args: any) {
  yield* sleep(0);
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN":
      {
        const params = arrArgs?.[1];
        const p = {
          ama: params?.thisAmaId ? params.thisAmaId : 0,
          apiName: "select",
          cancel: Boolean(params?.cancel),
          watch: Boolean(params?.watch),
        };
        // yield* put(pSubscribeListOfCtrDosare(p));
      }
      break;
    case "CLOSE": {
      // yield* put(pUnsubscribeListOfCtrDosare());
      break;
    }
    default: {
      break;
    }
  }
}

function* run_list_proforma_origin(args: any) {
  yield* sleep(0);
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
      };
      //yield* put(pSubscribeListOfProforme(p)); // << asta inscrie spre executare
      yield* put(getProformeOnSelectApi(p)); //
      break;
    }
    case "CLOSE": {
      yield* put(pUnsubscribeListOfProforme()); // << asta anuleaza actiunile recurente
      break;
    }
    default: {
      break;
    }
  }
}

function* run_list_invoice_origin(args: any) {
  yield* sleep(0);
  const arrArgs = ensureArray(args);
  switch (arrArgs?.[0]) {
    case "OPEN": {
      const params = arrArgs?.[1];
      const p = {
        ...params,
        watch: Boolean(params?.watch),
        cancel: Boolean(params?.cancel),
      };
      // console.log("p meaning what ?", p);
      yield* put(pSubscribeListOfInvoices(p));
      yield* put(getInvoiceOnSelectApi(p));
      break;
    }
    case "CLOSE": {
      yield* put(pUnsubscribeListOfInvoices());
      break;
    }
    default: {
      break;
    }
  }
}
